import { render, staticRenderFns } from "./TrSliderCanvas.vue?vue&type=template&id=8e0b94c6&scoped=true&"
import script from "./TrSliderCanvas.vue?vue&type=script&lang=js&"
export * from "./TrSliderCanvas.vue?vue&type=script&lang=js&"
import style0 from "./TrSliderCanvas.vue?vue&type=style&index=0&id=8e0b94c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0b94c6",
  null
  
)

export default component.exports